/* Cart drawer keyboard behaviour (added 18 Sept 2026, from the journey walk).

   Adding to cart opened the drawer and did three things wrong at once: focus
   stayed on the body, so a keyboard or screen reader user got no signal that
   anything had happened; the 114 focusable elements on the page behind it
   stayed in the tab order, so tabbing walked the page rather than the drawer;
   and Escape did nothing, leaving no way out without a mouse. This is the last
   step before checkout, so it is the worst place on the site for that.

   The theme owns the opening and closing. This only watches aria-hidden on the
   drawer and adds the behaviour around it: focus in on open, Tab cycled within
   the drawer while it is open, Escape closes through the theme's own toggle,
   and focus returned to whatever opened it. Nothing here re-renders the cart,
   so it cannot fight the theme's own drawer code.

   Focus is retried rather than set once, on the way in and on the way out.
   aria-hidden flips at the start of the drawer's slide, and a browser will not
   move focus to an element that is still visually hidden or mid-transition, so
   a single focus() call silently does nothing and strands the user on the body.

   On a mouse click the button that opened the drawer is often not focused at
   all (a click does not focus a button on every platform), so there is nothing
   to go back to and focus returns to the cart toggle in the header instead.
   Opened from the keyboard, which is the case this whole file exists for, the
   add button does hold focus and gets it back. */
(function () {
  var DRAWER = '#mini-cart';
  var TOGGLE = '[data-action="toggle-mini-cart"]';
  var SEL = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var TRIES = [0, 80, 200, 400];

  var drawer = document.querySelector(DRAWER);
  if (!drawer) return;

  var lastFocus = null;

  function isOpen() {
    return drawer.getAttribute('aria-hidden') === 'false';
  }

  function items() {
    return [].slice.call(drawer.querySelectorAll(SEL)).filter(function (el) {
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    });
  }

  function toggle() {
    return document.querySelector(TOGGLE);
  }

  function retry(fn) {
    TRIES.forEach(function (ms) { setTimeout(fn, ms); });
  }

  function onOpen() {
    var active = document.activeElement;
    if (active && active !== document.body && !drawer.contains(active)) lastFocus = active;
    if (!drawer.hasAttribute('tabindex')) drawer.setAttribute('tabindex', '-1');
    retry(function () {
      if (!isOpen()) return;
      if (drawer.contains(document.activeElement)) return;
      var f = items();
      (f[0] || drawer).focus();
    });
  }

  function onClose() {
    var back = lastFocus;
    lastFocus = null;
    if (!back || !back.focus || drawer.contains(back) || !document.contains(back)) {
      back = toggle();
    }
    if (!back || !back.focus) return;
    retry(function () {
      if (isOpen()) return;
      if (document.activeElement === back) return;
      if (!document.contains(back)) return;
      back.focus();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (!isOpen()) return;

    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      var t = toggle();
      if (t) t.click();
      return;
    }

    if (event.key !== 'Tab') return;

    var f = items();
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];

    if (!drawer.contains(document.activeElement)) {
      event.preventDefault();
      first.focus();
      return;
    }
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  new MutationObserver(function () {
    if (isOpen()) onOpen(); else onClose();
  }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });

  if (isOpen()) onOpen();
})();
